import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/Layout.jsx");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/Tabs.jsx")